import { _removeLocalKeys } from "network-helper";
import config from "../../config.json";
import { _removeItemFromSession, _getItemFromSession } from "./SessionKeys";
import { _getItemFromLocal, _removeItemFromLocal } from "./LocalKeys";

export const _removeAllLocalKeys = async () => {
    _removeItemFromLocal("_ippf");
    _removeItemFromLocal("_pp");
    _removeItemFromLocal("_cp");
    _removeItemFromLocal("_ppra");
    _removeItemFromLocal("_fud");
    _removeItemFromLocal("_fpd");
    _removeItemFromLocal("udf");
    if (_getItemFromLocal("_ru")) {
        _removeItemFromLocal("_ru");
    }
    _removeLocalKeys();
    _removeSessionKeys();
    _removeItemFromSession("_ga_uid");
    _removeItemFromSession("_tid");
};

const _removeSessionKeys = () => {
    if (_getItemFromSession("_pnp") !== null) {
        _removeItemFromSession("_pnp");
        _getItemFromLocal("_sr") !== null && _removeItemFromLocal("_sr");
        _getItemFromSession("removeSmartSwitch") !== null && _removeItemFromSession("removeSmartSwitch");
        _getItemFromSession("removeFamilySwitchInHeader") !== null &&
            _removeItemFromSession("removeFamilySwitchInHeader");
        _getItemFromSession("dashboard_title") !== null && _removeItemFromSession("dashboard_title");
        _getItemFromSession("removeLogoutButton") !== null && _removeItemFromSession("removeLogoutButton");
        _getItemFromSession("device_os_type") !== null && _removeItemFromSession("device_os_type");
    }
};

export const forceLogout = async (doNotRedirect = false) => {
    await _removeAllLocalKeys();
    if (!doNotRedirect) window.location.href = `${config.relativePath}`;
};
